import { Action } from 'redux';

import { ChangeCollectionVisibility } from '../../app/actions/AppActionTypes';
import { ICollectionInfo } from '../space/ICollectionInfo';

// TFS 1237812: Remove with CollectionsPermissions (collectionsPermissionsEnabled) feature flag
export interface ChangeCollectionVisibilityAction extends Action {
  targetItem: ICollectionInfo;
}

export function changeCollectionVisibility(targetItem: ICollectionInfo): ChangeCollectionVisibilityAction {
  return {
    type: ChangeCollectionVisibility,
    targetItem
  };
}
